export class ErrorResponse {
  code: string;
  message: string;
  translateKey?: string;
  categoryLv?: number;
}
